module.exports = __webpack_public_path__ + "static/card4-7c00390d0ddc9178d6660b1b75947fd3.png";